var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.computedClass},[(_vm.type === _vm.MY_REPORT)?_c('icon-check',{staticClass:"icon",attrs:{"size":14}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.getText()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }